export const PLASMIC_BLOGS_QUERY_KEY = "plasmic-blogs-data";

export const BE01_TABLE_ID = "be01";

export const CMS_FIELDS = {
  CARD_TYPE: "Card Type",
  IMAGE: "Image",
  IMAGE_ALT: "Image Alt",
  BUTTON_TEXT: "Button Text",
  BUTTON_URL: "Button Url",
  DESCRIPTION: "Description",
} as const;

export const CMS_SECTION_FIELDS = {
  HEADING: "heading",
  SEE_ALL_TEXT: "seeAllText",
  SEE_ALL_URL: "seeAllUrl",
  BLOG_CARD: "blogCard",
} as const;

export const CARD_TYPES = {
  TALL: "tall",
  REGULAR: "regular",
} as const;

export const SLIDER_WIDTH = {
  MIN_PERCENT: 15,
  MAX_PERCENT: 50,
} as const;

export const SCROLL_ANIMATION_DURATION = 0.6;
